import PropTypes from 'prop-types'
import { ChargingStationConnectorTypes } from '../../models/electric/charging-station-connector-types-enum'

export const chargingStationConnectorTypePropType = PropTypes.oneOf(Object.values(ChargingStationConnectorTypes))
